<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
					کارگروه
					<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>


			<div class="card card-style mb-2" v-for="item in WorkGroupList" :key="item.workGroupId" @click.prevent="openDetails(item.workGroupId)">
				<div class="list-group list-custom-small list-icon-0">
					<div class="list-group-div p-2">
						<div>
							<i class="fa fa-users text-warning"></i>
							<b class="font-15 text-dark">{{item.title}}</b>
						</div>
						<div class="d-flex justify-content-between">
							<div>
								<i class="fa fa-hashtag color-blue2-dark"></i>
								<span class="font-14 text-muted">{{item.code}}</span>
							</div>
							<span @click.stop="showMenu(item)" width="60px"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
						</div>
					</div>
				</div>
			</div>
			<div class="card card-style" v-if="WorkGroupList.length==0 && pageLoading==false">
				<div class="content">
					<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
					<p class="text-center py-3">هیج موردی یافت نشد.</p>
				</div>
			</div>
		</div>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'WorkGroupEdit', params: { WorkGroupId: workGroupId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>

					<button @click="DeleteWorkGroup" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoading==false" class="addBtn" id="addBtn" ref="addBtn" :style="{top:addButtonTop}">
				<router-link to="/WorkGroupCreate" class="btn px-3 py-2  rounded-xl bg-green2-light font-900 text-white shadow-xl border-green2-dark">
					<i class="fa fa-plus font-14"></i>
				</router-link>
			</div>
		</transition>
		<Help-Menu title="راهنمای تشکیل کارگروه و کاربرد آن" keyEn="WorkGroupList"></Help-Menu>
	</div>
</template>

<script>
	import VueSimpleAlert from 'vue3-simple-alert';
	import HelpMenu from '../Components/HelpMenu.vue';
	export default {
		components: {
			"Help-Menu": HelpMenu
		},
		data() {
			return {
				pageLoading: false,
				workGroupId: 0,
				list: []
			};
		},
		created() {
			this.GetWorkGroupList();
		},
		computed: {
			WorkGroupList() {
				return this.list;
			},
		},
		methods: {
			showAddButton() {
				this.pageLoaded = true;
			},
			showMenu(t) {
				this.workGroupId = t.workGroupId;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			DeleteWorkGroup() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm(
					"آیا مایل به حذف این مورد هستید؟",
					null,
					"question",
					{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
				).then(() => {
					this.pageLoading = true;
					this.$http
						.get("WorkGroup/Delete?id=" + this.workGroupId)
						.then((data) => {
							var res = data.data;
							this.pageLoading = false;
							if (res == "1") {
								this.GetWorkGroupList();
							} else {
								this.showErrorMessage(res);
							}
						});
				});
			},
			GetWorkGroupList() {
				this.pageLoading = true;
				this.$http
					.get("WorkGroup/GetList")
					.then((data) => {
						var res = data.data;
						this.list = res;
						this.pageLoading = false;
					});

			},
			openDetails(workGroupId) {
				this.$router.push({ name: 'WorkGroupEdit', params: { WorkGroupId: workGroupId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
		},
		mounted() {
			document
				.querySelectorAll(".menu-box-right")
				.forEach((a) => (a.style.display = "block"));
		},
	}
</script>